import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiLockLine } from '@remixicon/react';
import { rootRouteRef } from './routes';

const securityPage = PageBlueprint.make({
  params: {
    routeRef: rootRouteRef,
    path: '/security',
    title: 'Cyber Security',
    noHeader: true,
    icon: <RiLockLine />,
    loader: () =>
      import('./components/SecurityPage').then(m => <m.SecurityPage />),
  },
});

export const securityPlugin = createFrontendPlugin({
  pluginId: 'security',
  extensions: [securityPage],
  routes: {
    root: rootRouteRef,
  },
});
